import React from 'react'
// libs
import styled from 'styled-components'

const StyledIcon = styled.img``

interface Props {
  active: string
  hovered: string
  inactive: string
  isActive?: boolean
}

const DynamicIcon: React.FC<Props> = ({ active, inactive, hovered, isActive }) => {
  const [isHovered, setIsHovered] = React.useState(false)

  let current = inactive

  if (isHovered) {
    current = hovered
  }

  if (isActive) {
    current = active
  }

  return <StyledIcon src={current} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} />
}

export default DynamicIcon
